/**
 * @prettier
 * @flow
 */
export const en = {};
